module.exports = __webpack_public_path__ + "img/colombian-michelada.e25c69b6.jpg";